// MEMO: 静的アセットをwebpacker経由で利用する
//       https://railsguides.jp/webpacker.html#静的アセットをwebpacker経由で利用する

require.context("../images", true);
